import styled, { css } from 'styled-components';
import { layout } from 'src/components/base';

type ButtonProps = {
  size: 'small' | 'normal';
};

export const Button = styled.button<ButtonProps>(
  props => css`
    color: ${props.theme.text.callToAction};
    text-decoration: none;

    &:hover {
      color: ${props.theme.text.callToActionHover};
      cursor: pointer;
    }

    ${props.size === 'small' &&
      css`
        font-size: ${layout.measurements.fontSizeSmall};
      `}
  `
);

export const TextLabel = styled.div``;
export const Text = styled.div``;

type ShowMoreProps = {
  expanded: boolean;
  hideOnExpand: boolean;
  maxHeight: number;
};

export const ShowMore = styled.div<ShowMoreProps>(
  props => css`
    ${props.expanded &&
      props.hideOnExpand &&
      css`
        ${Button} {
          display: none;
        }
      `}

    ${!props.expanded &&
      css`
        ${TextLabel} {
          max-height: ${props.maxHeight}px;
          white-space: pre-line;
          overflow: hidden;
        }
      `}
  `
);
